// NOTE: adjust this import to your actual shared API helper path if different.
// Expected helpers: postBiz(service, action, payload), rows(response), json(response)
import { postBiz, rows, json } from '../core/coreapi';

export const normalizePpm = (r: any) => ({
  id: r.id ?? r.rid ?? r.recid,
  rid: r.rid ?? r.recid ?? r.id,
  shc: r.shc ?? r.shortcode ?? '',
  nam: r.nam ?? r.recname ?? '',
  fyr: r.fyr ?? r.fiscalyear ?? '',
  pst: r.pst ?? r.status ?? '',
  tam: Number(r.tam ?? r.totalamount ?? r.totalbudget ?? 0),
  fam: Number(r.fam ?? r.fonctionnement ?? 0),
  iam: Number(r.iam ?? r.investissement ?? 0),
  lct: Number(r.lct ?? r.linecount ?? 0),
  bvi: r.bvi ?? r.budgetversionid ?? null,
  bvc: r.bvc ?? r.budgetversioncode ?? '',
  aps: r.aps ?? r.approvalstage ?? '',
  raw: r,
});

export const normalizePpmLine = (r: any) => ({
  id: r.id ?? r.rid ?? r.recid,
  rid: r.rid ?? r.recid ?? r.id,
  ppi: r.ppi ?? r.ppmid,
  bvl: r.bvl ?? r.budgetversionlineid,
  sai: r.sai ?? r.superactivityid ?? null,
  sac: r.sac ?? r.superactivitycode ?? '',
  san: r.san ?? r.superactivityname ?? '',
  psc: r.psc ?? r.ppmsection ?? '',
  ccc: r.ccc ?? r.costcentercode ?? '',
  ccn: r.ccn ?? r.costcentername ?? '',
  acc: r.acc ?? r.accountcode ?? '',
  acn: r.acn ?? r.accountname ?? '',
  nam: r.nam ?? r.recname ?? r.activity ?? '',
  dsc: r.dsc ?? r.description ?? '',
  bga: Number(r.bga ?? r.budgetamount ?? 0),
  ara: Number(r.ara ?? r.arrears ?? 0),
  avc: Number(r.avc ?? r.availablecredit ?? 0),
  atx: r.atx ?? r.activitytext ?? '',
  pnt: r.pnt ?? r.nature ?? '',
  pmd: r.pmd ?? r.method ?? '',
  rvt: r.rvt ?? r.reviewtype ?? '',
  tpd: r.tpd ?? r.publicationdate ?? '',
  bsd: r.bsd ?? r.biddate ?? '',
  evd: Number(r.evd ?? r.evaluationdays ?? 0),
  psd: r.psd ?? r.startdate ?? '',
  exd: Number(r.exd ?? r.executiondays ?? 0),
  eed: r.eed ?? r.enddate ?? '',
  lot: r.lot ?? r.lotno ?? '',
  ruc: r.ruc ?? r.responsibleunit ?? '',
  pst: r.pst ?? r.status ?? '',
  _state: r._state || 'clean',
  raw: r,
});

export const normalizeSuperactivity = (r: any) => ({
  id: r.id ?? r.rid ?? r.recid,
  rid: r.rid ?? r.recid ?? r.id,
  ppi: r.ppi ?? r.ppmid,
  nam: r.nam ?? r.recname ?? '',
  shc: r.shc ?? r.shortcode ?? '',
  psc: r.psc ?? r.section ?? '',
  pmd: r.pmd ?? r.method ?? '',
  pnt: r.pnt ?? r.nature ?? '',
  rvt: r.rvt ?? r.reviewtype ?? '',
  gam: Number(r.gam ?? r.amount ?? 0),
  lct: Number(r.lct ?? r.linecount ?? 0),
});

export const generatePpm = (budgetVersionId: number, name: string) =>
  json(postBiz({s: 'ppm', a: 'generate', bvi: budgetVersionId, nam: name }));

export const fetchPpms = async (fiscalYear: string, status = '') =>
  rows(await postBiz({s: 'ppm', a: 'find', fyr: fiscalYear || null, pst: status || null, pgo: 0, pgl: 100 })).map(normalizePpm);

export const fetchPpmLines = async (ppmId: number, section = '', superActivityId: number | null = null) =>
  rows(await postBiz({s: 'ppm', a: 'lines', rid: ppmId, psc: section || null, sai: superActivityId })).map(normalizePpmLine);

export const savePpmLines = (ppmId: number, records: any[]) =>
  json(postBiz({s: 'ppm', a: 'bulksave', rid: ppmId, rcd: records }));

export const submitPpm = (ppmId: number, notes = '') =>
  json(postBiz({s: 'ppm', a: 'submit', rid: ppmId, nts: notes }));

export const approvePpm = (ppmId: number, notes = '') =>
  json(postBiz({s: 'ppm', a: 'approve', rid: ppmId, nts: notes }));

export const fetchSuperactivities = async (ppmId: number) =>
  rows(await postBiz({s: 'ppmsuperactivity', a: 'find', ppi: ppmId })).map(normalizeSuperactivity);

export const createSuperactivity = (payload: any) =>
  json(postBiz({s: 'ppmsuperactivity', a: 'create', ...payload} ));

export const assignSuperactivityLines = (superActivityId: number, lineIds: number[]) =>
  json(postBiz({s: 'ppmsuperactivity', a: 'assign', rid: superActivityId, ids: lineIds }));

export const fetchPpmCards = (ppmId: number) =>
  json(postBiz({s: 'ppmworkbench', a: 'cards', rid: ppmId }));

export const generatePpmCalendar = (ppmId: number) =>
  json(postBiz({s: 'ppmworkbench', a: 'calendarize', rid: ppmId }));

export const fetchPpmCalendar = async (ppmId: number) =>
  rows(await postBiz({s: 'ppmworkbench', a: 'calendar', rid: ppmId }));
